import { Group } from "../../../group";
import styles from "../../image.module.scss";
import { ImagePreviewToolboxProps } from "./toolbox.types";
import classnames from "classnames";
import { ZoomIn } from "./zoom-in";
import { ZoomOut } from "./zoom-out";
import { Reset } from "./reset";
import { Rotate } from "./rotate";
import { Previous } from "./previous";
import { Next } from "./next";
import { Close } from "./close";
import { Counts } from "./counts";

/**
 * A container for image preview interaction tools (zoom, rotate, reset, etc.).
 * Usually rendered at the bottom of the preview modal.
 *
 * @param {ImagePreviewToolboxProps} props - Component props.
 * @returns {JSX.Element} The toolbox container.
 */
export const ImagePreviewToolbox = ({ children, className }: ImagePreviewToolboxProps) => {
    return (
        <Group gap="xs" className={classnames(styles.toolbar, className)}>
            {children}
        </Group>
    );
};

ImagePreviewToolbox.ZoomIn = ZoomIn;
ImagePreviewToolbox.ZoomOut = ZoomOut;
ImagePreviewToolbox.Reset = Reset;
ImagePreviewToolbox.Rotate = Rotate;
ImagePreviewToolbox.Previous = Previous;
ImagePreviewToolbox.Next = Next;
ImagePreviewToolbox.Close = Close;
ImagePreviewToolbox.Counts = Counts;
